import { render } from "./AllSpaces.vue?vue&type=template&id=19d67f04"
import script from "./AllSpaces.vue?vue&type=script&lang=js"
export * from "./AllSpaces.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__